/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateColReceiveImporterErrorCmd } from '../../models/create-col-receive-importer-error-cmd';
import { ValidationError } from '../../models/validation-error';

export interface InsertColReceiveImporterErrors$Params {
      body?: CreateColReceiveImporterErrorCmd
}

export function insertColReceiveImporterErrors(http: HttpClient, rootUrl: string, params?: InsertColReceiveImporterErrors$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationError>>> {
  const rb = new RequestBuilder(rootUrl, insertColReceiveImporterErrors.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ValidationError>>;
    })
  );
}

insertColReceiveImporterErrors.PATH = '/api/collector/receiver_errors';
